function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.035 8.134L13.937.576a.554.554 0 00-.562 0L.281 8.134A.564.564 0 000 8.621v15.124a.56.56 0 00.281.487l13.094 7.562a.576.576 0 00.562 0l13.098-7.562a.566.566 0 00.277-.487V8.62a.564.564 0 00-.277-.487zM5.473 6.437l11.971 6.911-3.787 2.185L1.69 8.623l3.783-2.187zm3.265-1.888l11.971 6.913-2.135 1.236L6.603 5.785l2.135-1.236zm10.399 9.124l2.135-1.235v4.134l-1.066-.006a.57.57 0 00-.426.192l-.643.748v-3.833zM13.656 1.716l11.971 6.905-.564.325-3.227 1.865L9.869 3.898l3.787-2.183zM1.127 9.596l11.965 6.913v13.822L1.127 23.418V9.596zm25.062 13.822l-11.971 6.913V16.509l3.791-2.187v4.692a.559.559 0 00.564.562c.016 0 .023-.019.045-.024a.54.54 0 00.379-.17l1.463-1.692 1.375.005c.15 0 .293-.062.398-.168a.541.541 0 00.164-.396v-5.343l3.791-2.192v13.822h.001z",
  fill: "inherit",
  fillRule: "evenodd",
  strokeWidth: "inherit"
});

function SvgSendBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 32"
  }, props), _ref);
}

export default SvgSendBox;